import * as React from 'react';
import _ from 'lodash';

import { ITagWell, FlowcellControl, ITagPlateSample } from '@models/upload';
import Flowcell, { ITagWellStateProps } from './TagWell';
import './TagWells.scss';

export interface ITagWellsTagWell
  extends ITagWellStateProps,
    Pick<ITagPlateSample, 'controlType'>,
    Pick<ITagWell, 'string'> {}

export interface IFlowcellsStateProps {
  tagWells: ITagWellsTagWell[];
  selectedEmptyTagWell: string;
}

export interface IFlowcellsDispatchProps {
  select: (well: ITagWellsTagWell) => void;
  selectEmptyTagWell: (position: string) => void;
}

const columnCount = 12;
const rowCount = 8;

const flowcellControlCharacter = (
  control?: FlowcellControl
): string | undefined => {
  switch (control) {
    case FlowcellControl.none:
      return undefined;
    case FlowcellControl.positive:
      return '+';
    case FlowcellControl.negative:
      return '-';
  }
};

const Flowcells: React.FC<IFlowcellsStateProps & IFlowcellsDispatchProps> = ({
  tagWells,
  select,
  selectEmptyTagWell,
  selectedEmptyTagWell,
}) => {
  const rows: JSX.Element[] = [];
  const headerRows: JSX.Element[] = [];

  for (let row = 0; row <= rowCount; row++) {
    const columns: JSX.Element[] = [];
    for (let column = 0; column <= columnCount; column++) {
      const char = String.fromCharCode(64 + row);
      const position = `${char}${column}`;
      const tagWell = _.find(
        tagWells,
        (x: ITagWellsTagWell) => x.string === position
      );

      if (!row && !column) {
        columns.push(
          <th className='cell column-header row-header' key={position}></th>
        );
      } else if (!row) {
        columns.push(
          <th className='cell column-header' key={position}>
            {column}
          </th>
        );
      } else if (!column) {
        columns.push(
          <td className='cell row-header' key={position}>
            {char}
          </td>
        );
      } else {
        columns.push(
          <td className='cell' key={position}>
            {tagWell && (
              <Flowcell
                displayColor={tagWell.displayColor}
                selected={tagWell.selected}
                onClick={() => select(tagWell)}
                externalSubjectId={tagWell.externalSubjectId}
                character={flowcellControlCharacter(tagWell.controlType)}
              />
            )}
            {!tagWell && (
              <div
                className={`flowcell empty ${
                  selectedEmptyTagWell === position && 'selected'
                }`}
                onClick={() => selectEmptyTagWell(position)}
              >
                <div />
              </div>
            )}
          </td>
        );
      }
    }
    if (!row) {
      headerRows.push(<tr key={row}>{columns}</tr>);
    } else {
      rows.push(<tr key={row}>{columns}</tr>);
    }
  }

  return (
    <div className='flowcells'>
      <table className='content'>
        <thead>{headerRows}</thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default Flowcells;
